import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'firmware-status-dialog',
    styleUrls: ['./firmware-status-dialog.component.less'],
    template: `
    <h2 mat-dialog-title align="center">Setting Default Firmware</h2>
    @if (isLastStepInProgress()) {
      <mat-progress-bar
        mode="indeterminate"
        color="accent"
        style="margin-bottom: 16px;">
      </mat-progress-bar>
    }
    <mat-dialog-content class="status-content">
      @if (data.status) {
        <div>
          <div>
            <strong>Correlation ID:</strong> {{ data.status.correlationId }}
          </div>
          <div>
            <strong>Process Type:</strong> {{ data.status.processType }}
          </div>
          @for (step of data.status.processSteps; track step) {
            <div>
              <div style="margin-top: 1em;">
                <strong>Step {{ step.processStepId }}:</strong> {{ step.description }}
                <ul>
                  @for (status of step.processStepStatuses; track status) {
                    <li>
                      <span>Status: {{ status.status }}</span>
                      <span> | Last Updated: {{ status.lastUpdated | date:'short' }}</span>
                      @if (status.processStepErrorResult) {
                        <span>
                          | <span style="color: red;">Error: {{ status.processStepErrorResult.reason }}</span>
                        </span>
                      }
                    </li>
                  }
                </ul>
              </div>
            </div>
          }
        </div>
      }
      @if (!data.status) {
        <div>
          Waiting for status...
        </div>
      }
    </mat-dialog-content>
    <mat-dialog-actions align="center">
      <button class="btn button-fix button-color-fix-red" mat-button (click)="onClose()">Close</button>
    </mat-dialog-actions>
    `,
    standalone: false,
})
export class DialerFirmwareStatusDialogComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<DialerFirmwareStatusDialogComponent>) { }

    onClose() {
        this.dialogRef.close();
    }

    getLastStep(): any {
        // Get the last process step
        if (!this.data.status?.processSteps) {
            return null;
        }
        return this.data.status.processSteps[this.data.status.processSteps.length - 1];      
    }

    isLastStepInProgress(): boolean {
        const step = this.getLastStep();
        if (!step || !step.processStepStatuses?.length) {
            return false;
        }
        const lastStatus = step.processStepStatuses[step.processStepStatuses.length - 1];
        return lastStatus.status?.toLowerCase() !== 'finished' && lastStatus.status?.toLowerCase() !== 'failed';
    }

}
